export class DropDownItemClickEvent extends Event {
   static EVENT_NAME = 'atlantis-dropdown-item-click';
   constructor() {
      super(DropDownItemClickEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
      });
   }
}
